module.exports = __webpack_public_path__ + "img/services-activity-3.9bc74036.svg";